import { useState } from "react";
import "./index.css";

import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import RequestCallButton from "../../components/CallReqButton";
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import { Helmet } from "react-helmet-async";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { PiUsersBold } from "react-icons/pi";
import { GoDotFill } from "react-icons/go";

const courses = [
  {
    id: 1,
    title: "Full Stack Course - (MERN)",
    tag: "Tech Pro",
    desc: "Full Stack Developer Program with real-world projects, and internship support. Designed to help you achieve high-paying software jobs like IITians.",
    img: "https://iqteche.in/static/media/wl_client_images/06c8bec895b14baf94776a2646b647ff.jpg",
    journey: [
      "Frontend Development - (HTML, CSS, BootStrap,Tailwind CSS, JavaScript, ReactJS)",
      "Backend Development - (SQL, NodeJS, ExpressJS, MongoDB)",
      "Python Programming Language",
      "Real Time Projects - (Netflix, Amazon, Zomato/Swiggy, and more...)",
      "Internship Support 🚀",
      "Mock Interviews with industry experts",
      "ATS friendly Resume Building",
    ],
    category: "fullstack",
    salary: "Get High-Paid Job Upto 12LPA",
    actualPrice: "1,20,000",
    offerPrice: "45,000",
  },
  {
    id: 2,
    title: "Full Stack Course - (MERN)",
    tag: "Tech Smart",
    desc: "Full Stack Developer Program in  with real-world projects and career focused training to get high-paying jobs like IITians.",
    img: "https://iqteche.in/static/media/wl_client_images/e83c5ad74ed746e8afcecd1269e1fc0a.jpg",
    journey: [
      "Frontend Development - (HTML, CSS, BootStrap,Tailwind CSS, JavaScript, ReactJS)",
      "Backend Development - (SQL, NodeJS, ExpressJS, MongoDB)",
      "Real Time Projects - (Limited)",
      "Mock Interviews with industry experts",
      "Resume Building",
    ],
    category: "fullstack",
    salary: "Get High-Paid Job Upto 10LPA",
    actualPrice: "75,000",
    offerPrice: "25,000",
  },

  {
    id: 3,
    title: "Artificial Intelligence & Machine Learning",
    tag: "4.0 Technology",
    desc: "Powering the Future with Industry 4.0 Intelligence",
    img: "https://iqteche.in/static/media/wl_client_images/b28a93f0ba5a45878cfafb436635e30a.jpg",
    journey: [
      "Basics of Computer Science & Math",
      "Data Handling & Visualization",
      "Machine Learning (ML)",
      "Deep Learning (DA)",
      "Natural Language Processing (NLP)",
      "Reinforcement Learning (RL)",
      "MLOps & Deployment",
      "Advance AI Topics",
      "Master AI",
      "Work on real-world projects",
      "Mock Interviews With Industry Experts",
      "ATS Friendly Resume Building",
    ],
    category: "specializations",
    salary: "Get High-Paid Job Upto 24LPA",
    actualPrice: "1,50,000",
    offerPrice: "75,000",
  },

  {
    id: 4,
    title: "Data Science",
    tag: "4.0 Technology",
    desc: "Empowering Business Intelligence with 4.0 Tech",
    img: "https://iqteche.in/static/media/wl_client_images/a8611c85c127489aa86969a57c0862a4.jpg",
    journey: [
      "Core Foundations",
      "Data Handling and Preprocessing",
      "Data Visualization & Exploratory Data Analysis (EDA)",
      "Databases & SQL",
      "Model Deployment MLOps (Advanced)",
      "Business & Domain Knowledge",
      "Real-World Projects & Portfolio Building",
      "Mock Interviews With Industry Experts",
    ],
    category: "specializations",
    salary: "Get High-Paid Job Upto 24LPA",
    actualPrice: "1,50,000",
    offerPrice: "75,000",
  },

  {
    id: 5,
    title: "Cyber Security",
    tag: "4.0 Technology",
    desc: "Shielding the Future of Digital Transformation",
    img: "https://iqteche.in/static/media/wl_client_images/fd0a4b011f8c48189b47471dd60701ee.jpg",
    journey: [
      "Computer & Networking Fundamentals",
      "Lean Operating System (Linux)",
      "Security Concepts and Fundamentals",
      "Networking Security & Firewalls",
      "Ethical Hacking & Penetration Testing",
      "Web Application Security",
      "Cryptography",
      "Security Operations Center (SOC) Skills",
      "Governance, Compliance & Legal",
      "Advanced Topics (Read Teaming, Malware Analysis)",
      "Mock Interviews With Industry Experts",
    ],
    category: "specializations",
    salary: "Get High-Paid Job Upto 24LPA",
    actualPrice: "1,50,000",
    offerPrice: "75,000",
  },

  {
    id: 6,
    title: "AR - VR",
    tag: "4.0 Technology",
    desc: "Revolutionizing Human Experience with AR/VR",
    img: "https://iqteche.in/static/media/wl_client_images/e11929b650874f7d9c64fcc8bd0febf5.jpg",
    journey: [
      "Understanding AR/VR Fundamentals",
      "Learn 3D Game Engines",
      "Understanding 3D Modeling & Assets",
      "Augmented Reality (AR) Development",
      "Virtual Reality (VR) Development",
      "Interaction Design & UX for AR/VR",
      "Advanced AR/VR Features",
      "Web-based AR/VR (WebXR)",
      "Testing Development, Deployment & Publishing",
      "Real-World Projects & Portfolio Building",
      "Mock Interviews With Industry Experts",
    ],
    category: "specializations",
    salary: "Get High-Paid Job Upto 24LPA",
    actualPrice: "1,50,000",
    offerPrice: "75,000",
  },

  {
    id: 7,
    title: "Block Chain",
    tag: "4.0 Technology",
    desc: "Secure. Transparent. Immutable – Powered by 4.0",
    img: "https://iqteche.in/static/media/wl_client_images/4af3b8a3f4a04feeb7a13860f7bb17de.jpg",
    journey: [
      "Basics of Blockchain Technology",
      "Programming Fundamentals (Focus on Web3 Stack)",
      "Data Structures & Cryptography Basics",
      "Explore Blockchain Platforms",
      "Smart Contract Development",
      "Decentralized Applications (dApps)",
      "NFT & Token Standards",
      "Decentralized Finance (DeFi)",
      "Smart Contract Security & Auditing",
      "Advanced Blockchain Development",
      "Blockchain DevOps & Deployment",
      "Real-World Projects & Portfolio Building",
      "Mock Interviews With Industry Experts",
    ],
    category: "specializations",
    salary: "Get High-Paid Job Upto 24LPA",
    actualPrice: "1,50,000",
    offerPrice: "75,000",
  },

  {
    id: 8,
    title: "PowerBi",
    tag: "In-Demand Tech Tool",
    desc: "Power BI Course with Certification and Placement Assistance. Unlock the Future with the Power of Data",
    img: "https://iqteche.in/static/media/wl_client_images/485defa014c24bb19f5f3dc9b061b821.jpg",
    journey: [
      "Understand What Power BI Is",
      "Started with Power BI Desktop",
      "Data Loading and Transformation (Power Query)",
      "Data Modeling",
      "DAX (Data Analysis Expressions)",
      "Creating Visualizations",
      "Advanced Analytics & Insights",
      "Power BI Service & Dashboard Sharing",
      "Power BI Advanced Features",
      "Real-Time Dashboards & Gateways",
      "Real-World Projects & Portfolio Building",
      "Mock Interviews With Industry Experts",
    ],
    category: "tech-tools",
    salary: "Get Tech Job Upto 6LPA",
    actualPrice: "45,000",
    offerPrice: "15,000",
  },

  {
    id: 9,
    title: "AWS",
    tag: "In-Demand Tech Tool",
    desc: "AWS Cloud Computing Course with Certification and Career Assistance. Transforming Tech Dreams into Cloud Reality",
    img: "https://iqteche.in/static/media/wl_client_images/366c1f652deb4b6396f40bcdf487b879.jpg",
    journey: [
      "Cloud Computing Fundamentals",
      "AWS Core Services (Foundation Layer)",
      "Identity, Access & Security",
      "AWS Databases",
      "Monitoring, Logging & Notifications",
      "Serverless Services (Modern Cloud)",
      "DevOps & Automation on AWS",
      "Advanced Networking & Hybrid Cloud",
      "Cost Management & Billing",
      "High Availability, Scalability & Disaster Recovery",
      "Real-World Projects & Portfolio Building",
      "Mock Interviews With Industry Experts",
    ],
    category: "tech-tools",
    salary: "Get Tech Job Upto 6LPA",
    actualPrice: "45,000",
    offerPrice: "15,000",
  },

  {
    id: 10,
    title: "ServiceNow",
    tag: "In-Demand Tech Tool",
    desc: "ServiceNow Developer Training with Internship and Job Assistance. Driving Digital Change with Workflow Intelligence",
    img: "https://iqteche.in/static/media/wl_client_images/f38cc4e7541c41ed8e4cd881ae327a8c.png",
    journey: [
      "Fundamentals of Tech and ServiceNow",
      "Core Platform Features",
      "ServiceNow Administration",
      "Scripting in ServiceNow",
      "Workflow & Flow Designer",
      "Service Catalog & Request Management",
      "Integration (Mid-Level)",
      "Advanced Development (Custom Applications)",
      "Reporting and Performance Analytics",
      "Governance, Upgrades & Best Practices",
      "Real-World Projects & Portfolio Building",
      "Mock Interviews With Industry Experts",
    ],
    category: "tech-tools",
    salary: "Get Tech Job Upto 6LPA",
    actualPrice: "45,000",
    offerPrice: "15,000",
  },

  {
    id: 11,
    title: "Data Analyst",
    tag: "In-Demand Tech Tool",
    desc: "Data Analyst Training Program with Placement Guidance.",
    img: "https://res.cloudinary.com/dyvxdlyrr/image/upload/v1782198784/data_analyst_x5zx6o.jpg",
    journey: [
      "Data Analytics Fundamentals",
      "Choose Your Analytics Career Track",
      "Data Handling & Database Skills (Excel / SQL)",
      "Python for Data Analytics",
      "Data Visualization & Dashboarding",
      "Statistics for Data-Driven Decisions",
      "Business Intelligence & Reporting",
      "Advanced Analytics & AI Concepts",
      "Mock Interviews With Industry Experts",
    ],
    category: "tech-tools",
    salary: "Get Tech Job Upto 6LPA",
    actualPrice: "45,000",
    offerPrice: "15,000",
  },
];

const textArray = [
  "Data Scientist",
  "AI Developer",
  "Machine Learning Developer",
  "AR/VR Developer",
  "Cyber Security Analyst",
]; //

const cardData = [
  {
    id: 1,
    icon: "https://iqteche.in/static/media/wl_client_images/029182d6911e48a0a685bf78d2c1fe57.png",
    text: "From Classrooms to Career Paths: Start at IBIX Academy after 12th",
  },
  {
    id: 2,
    icon: "https://iqteche.in/static/media/wl_client_images/49c16be89cef4ba4950422583c4b75e2.png",
    text: "Enhance your academic journey with just 4 hours of guided learning each week",
  },
  {
    id: 3,
    icon: "https://iqteche.in/static/media/wl_client_images/0be9fbc92c7d4344a84e3ddfdb15b71a.png",
    text: "Achieve a rewarding software job regardless of your academic background",
  },
];

const TypingAnimation = () => {
  const typingSpeed = 20; // Speed of typing (in ms per character) - Faster typing
  const backspaceSpeed = 20; // Speed of backspace effect
  const delayBetweenTexts = 1500; // Delay before starting the next text (optional, can adjust)

  const [currentText, setCurrentText] = useState(""); // Text being typed or deleted
  const [textIndex, setTextIndex] = useState(0); // Index of the current text in the array
  const [charIndex, setCharIndex] = useState(0); // Index of the current character
  const [isDeleting, setIsDeleting] = useState(false); // Flag to indicate if we are deleting text

  useEffect(() => {
    if (isDeleting) {
      if (charIndex > 0) {
        const timeout = setTimeout(() => {
          setCurrentText((prev) => prev.slice(0, -1)); // Delete last character
          setCharIndex((prev) => prev - 1);
        }, backspaceSpeed);
        return () => clearTimeout(timeout);
      } else {
        const timeout = setTimeout(() => {
          setIsDeleting(false); // Switch to typing mode after backspace
          setTextIndex((prev) => (prev + 1) % textArray.length); // Loop to the next text
        }, delayBetweenTexts);
        return () => clearTimeout(timeout);
      }
    } else {
      if (charIndex < textArray[textIndex].length) {
        const timeout = setTimeout(() => {
          setCurrentText((prev) => prev + textArray[textIndex][charIndex]);
          setCharIndex((prev) => prev + 1);
        }, typingSpeed);
        return () => clearTimeout(timeout);
      } else {
        const timeout = setTimeout(() => {
          setIsDeleting(true); // Start deleting the text after typing is finished
        }, delayBetweenTexts);
        return () => clearTimeout(timeout);
      }
    }
  }, [charIndex, textIndex, isDeleting]);

  return (
    <>
      <span className="typing-text">{currentText}</span>
      <span className="cursor"></span>
    </>
  );
};

const ExploreCourses = () => {
  const [openId, setOpenId] = useState(null);
  const [activeCourseButton, setCourseButtonTab] = useState(true);
  const { pathname } = useLocation();
  const [filterCourse, setFilterCourse] = useState([]);
  const { setActiveRoute, setActiveSection } = useContext(AppContext);
  // const [courses, setCourses] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState("");

  useEffect(() => {
    setActiveRoute("/courses");
    setActiveSection("courses");
  }, [setActiveRoute, setActiveSection]);

  useEffect(() => {
    const constFilterCards = courses.filter(
      (item) => `/courses/${item.category}` === pathname,
    );
    setFilterCourse(constFilterCards);
  }, [pathname]);

  const toggleDetails = (id) => {
    setOpenId(openId === id ? null : id);
  };

  const NoOppositeContent = ({ journey, salary }) => {
    return (
      <Timeline
        sx={{
          [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
          },
        }}
      >
        {journey.map((item, idx) => (
          <TimelineItem key={idx}>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>

            <TimelineContent className="course-journey-item">
              {item}
            </TimelineContent>
          </TimelineItem>
        ))}
        <p>🔥{salary}</p>
      </Timeline>
    );
  };

  const getTitle = () => {
    if (pathname === "/courses/fullstack") {
      return (
        <h1 className="success-stories-heading">
          <span>Full Stack Developer Course</span> with Internship & Placement
          Assistance
        </h1>
      );
    } else if (pathname === "/courses/specializations") {
      return (
        <section className="typing-animation-cont">
          <div className="d-none d-lg-block">
            <h1 className="type-animation-heading">
              A Powerful Program Designed to Make You a{" "}
              <span>
                <TypingAnimation />
              </span>
            </h1>
          </div>
          <div className=" d-lg-none">
            <h1 className="type-animation-heading">
              A Powerful Program Designed to Make You a <br />
              <span>
                <TypingAnimation />
              </span>
            </h1>
          </div>
        </section>
      );
    }
    return (
      <h1 className="success-stories-heading">
        <span>Power BI, ServiceNow,</span>
        <br /> AWS, SAP Course Training with Job Assistance
      </h1>
    );
  };

  const getHelmetAndMetaTitle = () => {
    if (pathname === "/courses/fullstack") {
      return (
        <Helmet>
          <title>
            Full Stack Developer Course in Hyderabad | Hands-on Training &
            Internship
          </title>
          <meta
            name="description"
            content="Become a job-ready full stack developer with IBIX Qodify. Learn front-end & back-end technologies through live classes, real-time projects, and internship support in Hyderabad."
          />
          <link rel="canonical" href="https://ibixqt.in/courses/fullstack" />
        </Helmet>
      );
    } else if (pathname === "/courses/specializations") {
      return (
        <Helmet>
          <title>
            Top IT Specializations in Hyderabad | Data Science, AI/ML, Cyber
            Security
          </title>
          <meta
            name="description"
            content="Explore top job-ready IT courses at IBIX Qodify including Data Science, AI/ML, Cyber Security, and more. Live training, hands-on projects, and internship support in Hyderabad."
          />
          <link
            rel="canonical"
            href="https://ibixqt.in/courses/specializations"
          />
        </Helmet>
      );
    } else if (pathname === "/courses/tech-tools") {
      return (
        <Helmet>
          <title>
            Job-Oriented Software Tools Training in Hyderabad | Power BI, AWS,
            SAP
          </title>
          <meta
            name="description"
            content="IBIX Qodify offers practical training for students, freshers and working professionals in tools like AWS, ServiceNow, SAP, Power BI, and more. Live classes and project-based learning in Telugu & English."
          />
          <link rel="canonical" href="https://ibixqt.in/courses/tech-tools" />
        </Helmet>
      );
    } else {
      return null; // fallback
    }
  };

  const ComparisonTable = () => {
    return (
      <div className="comparison-container container">
        <h2 className="success-stories-heading text-center">
          Why Choose <span> IBIX?</span>
        </h2>
        <div className="d-flex justify-content-center align-items-center">
          {" "}
          <table className="comparison-table">
            <thead className="table-headings">
              <tr>
                <th className="heading-th-1"></th>
                <th className="heading-th-2">IBIX Courses</th>
                {/* <th className="heading-th-3">Other Coaching Institutes</th> */}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="feature-name">Curriculum</td>
                <td className="intensive-feature">
                  Our curriculum is designed to align with today’s industry
                  needs.
                </td>
                {/* <td className="other-feature">Not industry-aligned</td> */}
              </tr>

              <tr>
                <td className="feature-name">Trainers</td>
                <td className="intensive-feature">
                  NRIs to tech giants like IBM and Google, innovators shaping
                  world-class products
                </td>
                {/* <td className="other-feature">
                No real world project experience
              </td> */}
              </tr>
              <tr>
                <td className="feature-name">Projects</td>
                <td className="intensive-feature">
                  Work on 15+ real-time projects to build a powerful resume
                </td>
                {/* <td className="other-feature">
                For only select branches, degrees
              </td> */}
              </tr>

              <tr>
                <td className="feature-name">Institute Recognised by</td>
                <td className="intensive-feature">
                  Recognized by <strong className="nasscom">MCA</strong>
                </td>
                {/* <td className="other-feature">No recognition</td> */}
              </tr>
              <tr>
                <td className="feature-name">Payment Mode</td>
                <td className="intensive-feature">
                  Simple UPI Payment, no EMI tension, no Loan issues, no CIBIL
                  effects.
                </td>
                {/* <td className="other-feature">~1-2 real time projects</td> */}
              </tr>

              <tr>
                <td className="feature-name"> Mock Interviews</td>
                <td className="intensive-feature">
                  HR Professionals and Domain Experts Will Jointly Conduct the
                  Mock Test.
                </td>
                {/* <td className="other-feature cross-mark">✗</td> */}
              </tr>
            </tbody>
          </table>
          <h3 className="m-3 d-none d-lg-block">V/S</h3>
          <table className="comparison-table other-comp-tb">
            <thead className="table-headings">
              <tr>
                <th className="heading-th-3">Other Coaching Institutes</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="other-feature">
                  Many institutes still follow an outdated curriculum
                </td>
              </tr>
              <tr>
                <td className="other-feature">
                  Doubt support to short hours, only 1–2 mentors per batch.
                </td>
              </tr>
              <tr>
                <td className="other-feature">
                  Provide outdated assignments instead of real-time projects.
                </td>
              </tr>

              <tr>
                <td className="other-feature">Unrecognized institutes</td>
              </tr>

              <tr>
                <td className="other-feature">
                  Other institutes push students into EMI plans, loans, and
                  CIBIL risks.
                </td>
              </tr>
              <tr>
                <td className="other-feature">
                  Mock tests are handled only by HR staff only
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const getPricing = () => {
    if (pathname === "/courses/fullstack") {
      return (
        <div className="container ">
          <div className="">
            <h3>Choose Your Course Track</h3>
            <div className="switchButtons">
              <button
                className={`${
                  activeCourseButton ? "active-button" : "inactive-button"
                } m-1`}
                onClick={() => setCourseButtonTab(true)}
              >
                Tech Pro
              </button>
              <button
                className={`${
                  activeCourseButton ? "inactive-button" : "active-button"
                } m-1`}
                onClick={() => setCourseButtonTab(false)}
              >
                Tech Smart
              </button>
            </div>

            <div className="course-fee-cont mt-2">
              {activeCourseButton ? (
                <div className="mb-3">
                  <h3>Actual Price</h3>
                  <p>
                    <span className="actual-fee">
                      <FaIndianRupeeSign />
                      1,25,000/-
                    </span>
                  </p>
                </div>
              ) : (
                <div className="mb-3">
                  <h3>Actual Price</h3>
                  <p>
                    <span className="actual-fee">
                      <FaIndianRupeeSign />
                      90,000/-
                    </span>
                  </p>
                </div>
              )}

              <div className="">
                {activeCourseButton ? (
                  <div className="">
                    <h3>DISCOUNT PRICE</h3>
                    <p className="offer-fee-para">
                      <span className="offer-fee">
                        <FaIndianRupeeSign />
                        60,000/-
                      </span>
                    </p>
                  </div>
                ) : (
                  <div>
                    <h3>DISCOUNT PRICE</h3>
                    <p className="offer-fee-para">
                      <span className="offer-fee">
                        <FaIndianRupeeSign />
                        40,000/-
                      </span>
                    </p>
                  </div>
                )}
              </div>

              <img
                src="https://iqteche.in/static/media/wl_client_images/9e2b19909ccf4a3da8b2426bf8c13ca4.png"
                alt="course fee"
                className="discount-img d-none d-lg-block"
              />
            </div>
          </div>
        </div>
      );
    } else if (pathname === "/courses/specializations") {
      return (
        <div className="container ">
          <div className="">
            <h3>Advanced 4.0 Technologies</h3>

            <div className="course-fee-cont mt-2">
              <div>
                <h3>Actual Price</h3>
                <p>
                  <span className="actual-fee">
                    <FaIndianRupeeSign />
                    1,85,000/-
                  </span>
                </p>
              </div>

              <div className="">
                <div>
                  <h3>DISCOUNT PRICE</h3>
                  <p className="offer-fee-para">
                    <span className="offer-fee">
                      <FaIndianRupeeSign />
                      90,000/-
                    </span>
                  </p>
                </div>
              </div>

              <img
                src="https://iqteche.in/static/media/wl_client_images/9e2b19909ccf4a3da8b2426bf8c13ca4.png"
                alt="course fee"
                className="discount-img d-none d-lg-block"
              />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="container ">
        <div className="">
          <h3>Learn AWS, SAP, ServiceNow, Power BI and Trending Tech Tools</h3>

          <div className="course-fee-cont mt-2">
            <div>
              <h3>Actual Price</h3>
              <p>
                <span className="actual-fee">
                  <FaIndianRupeeSign />
                  40,000/-
                </span>
              </p>
            </div>

            <div className="">
              <div>
                <h3>DISCOUNT PRICE</h3>
                <p className="offer-fee-para">
                  <span className="offer-fee">
                    <FaIndianRupeeSign />
                    18,000/-
                  </span>
                </p>
              </div>
            </div>

            <img
              src="https://iqteche.in/static/media/wl_client_images/9e2b19909ccf4a3da8b2426bf8c13ca4.png"
              alt="course fee"
              className="discount-img d-none d-lg-block"
            />
          </div>
        </div>
      </div>
    );
  };

  const renderAboutIBIXCourses = () => {
    return (
      <section className="main-section-container">
        <section className="container pb-5 pt-2">
          <h2 className="success-stories-heading text-center">
            <span> What Matters More in Tech</span> <br /> Your Degree{" "}
            <span style={{ color: "red" }}>or</span> Your Skills?{" "}
          </h2>

          <div className="row">
            {/* image container 1  */}
            <div className="col-12 col-md-6 mb-4">
              <div className="about-degree-cont">
                {/* <img
                  src="https://iqteche.in/static/media/wl_client_images/91978ee7c48745fda4c2cac79f46a8d2.png"
                  alt="Elon Musk"
                  className="w-100"
                /> */}
                <h3>You Don't Need A College Degree</h3>
                <p>
                  Elon Musk has expressed skepticism about the necessity of a
                  traditional college degree for success, particularly in
                  technical fields. He emphasizes the importance of practical
                  skills, problem-solving abilities, and a strong work ethic
                  over formal qualifications.
                </p>
                <span>-Elon Musk</span>
              </div>
            </div>

            {/* image container 2  */}
            <div className="col-12 col-md-6  mb-4">
              <div className="about-degree-cont">
                {/* <img
                  src="https://iqteche.in/static/media/wl_client_images/91978ee7c48745fda4c2cac79f46a8d2.png"
                  alt="Elon Musk"
                  className="w-100"
                /> */}
                <h3>The First Company That Springs To Mind</h3>
                <p>
                  Doesn’t require a college degree is get a job at Google, keep
                  in mind that the company requires particular skills and
                  professional expertise. If you lack the required skills, you
                  won’t get hired even if you don’t have a college degree or
                  certificate.
                </p>
                <span>-Sergey Brin</span>
              </div>
            </div>

            {/* image container 3  */}
            <div className="col-12 col-md-6  mb-4">
              <div className="about-degree-cont">
                {/* <img
                  src="https://iqteche.in/static/media/wl_client_images/91978ee7c48745fda4c2cac79f46a8d2.png"
                  alt="Elon Musk"
                  className="w-100"
                /> */}
                <h3>A College Dropout, Build a Company.</h3>
                <p>
                  Apple has also made it clear that having a degree is not
                  necessary; instead, they are searching for candidates with the
                  appropriate talents and job-related competencies. It all comes
                  down to training since at these large corporations, new hires
                  typically receive training before becoming full-fledged
                  employees.
                </p>
                <span>-Steve Jobs</span>
              </div>
            </div>

            {/* image container 4  */}
            <div className="col-12 col-md-6  mb-4">
              <div className="about-degree-cont">
                {/* <img
                  src="https://iqteche.in/static/media/wl_client_images/91978ee7c48745fda4c2cac79f46a8d2.png"
                  alt="Elon Musk"
                  className="w-100"
                /> */}
                <h3>Palantir CEO about Degree Certifications</h3>
                <p>
                  Certifications are not a barrier to employment at Palantir
                  company focuses on assessing candidates' abilities through
                  their own testing process, regardless of educational
                  background or certifications. Palantir's approach prioritizes
                  demonstrated skills and potential over traditional
                  credentials.
                </p>
                <span>- Alex Karp</span>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-light pt-5 pb-3 ps-1 pe-1">
          <h2 className="success-stories-heading text-center ">
            <span>The Next-Gen Learning Hub</span> to Supercharge Your Career
            with Advanced Tech Training.
          </h2>

          <div className="container ">
            <div className="row">
              <div className="col-12 col-md-6 mb-3">
                <div className="d-flex align-items-center support-card">
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/556b2f46209749dcb6023daf497ae4cc.png"
                    alt="course-support"
                    className="course-support-img"
                  />
                  <div className="ms-4">
                    <h5>Live Sessions (Every-Saturday)</h5>
                    <p>
                      Learn coding in the easiest way, get ready for interviews,
                      and solve doubts with expert support.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 mb-3">
                <div className="d-flex align-items-center support-card">
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/edc98df564164a1fb679aa0f44535f4c.png"
                    alt="course-support"
                    className="course-support-img"
                  />
                  <div className="ms-4">
                    <h5>Interaction with Domain Experts</h5>
                    <p>Making your learning path simple and stress-free.</p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 mb-3">
                <div className="d-flex align-items-center support-card">
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/48be489f642b4b0387f09f82c6516f4f.png"
                    alt="course-support"
                    className="course-support-img"
                  />
                  <div className="ms-4">
                    <h5>Masterclasses by Industry Experts and NRI's</h5>
                    <p>
                      Stay ahead with trending skills and job-ready knowledge
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 mb-3">
                <div className="d-flex align-items-center support-card">
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/876f0cee20b84fada663a13b59dd1d5e.png"
                    alt="course-support"
                    className="course-support-img"
                  />
                  <div className="ms-4">
                    <h5>One-on-one personal care and guidance</h5>
                    <p>
                      Dedicated support and personal guidance to make learning
                      easier for every student
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 mb-3">
                <div className="d-flex align-items-center support-card">
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/3370e769cdcb449eb6c7d799774a57bc.png"
                    alt="course-support"
                    className="course-support-img"
                  />
                  <div className="ms-4">
                    <h5>Mock Interviews</h5>
                    <p>
                      Industry-Style Mock Interviews with Tech and HR Guidance
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-6 mb-3">
                <div className="d-flex align-items-center support-card">
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/c10e90992a064cb3be2598c408b06312.png"
                    alt="course-support"
                    className="course-support-img"
                  />
                  <div className="ms-4">
                    <h5>Placement Support Assistant</h5>
                    <p>
                      Personalized guidance and tips to improve your performance
                      and boost confidence in interviews
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <RequestCallButton />
        </section>

        {/* kickstart */}
        <section className="career-roadmap">
          <h2 className="success-stories-heading text-center">
            <span>Build Your IT Career Roadmap in 3 Steps</span>
          </h2>
          <ul className="steps">
            <li>
              <span className="step-number">1</span>
              <p>Start Your Journey with us</p>
            </li>
            <li>
              <span className="step-number">2</span>
              <p>Learn & Build Real-Time Projects</p>
            </li>
            <li>
              <span className="step-number">3</span>
              <p>Get Certified & Land Your Dream Job</p>
            </li>
          </ul>
        </section>

        <section className="hero">
          <div className="hero-text">
            <h2 className="success-stories-heading text-center">
              <span>One-on-One</span> <br /> Doubt Support, Quicker than Offline
            </h2>
            <p>
              Our expert team is available from <strong>11 AM to 8 PM</strong>.
              on working days to help you with your doubts
            </p>
          </div>
          {/* Bottom Card */}
          <div className="hero-card ">
            <img
              src="https://iqteche.in/static/media/wl_client_images/bf351d3ccbd543a39d8d494f16d3d390.png"
              alt="experienced mentors"
              className="hero-card-img"
            />
            <div>
              <h3>
                25+ Experienced Mentors Are Allocated To Ensure Consistent
                Support For Each Batch.
              </h3>
              <p>
                Supported by Subject Matter Experts, NRIs, Teaching Assistants,
                and distinguished IBIX Alumni.
              </p>
            </div>
          </div>
          {/* WhatsApp Chat Button */}
          <a
            href="https://wa.me/9100884508"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-btn"
          >
            <i className="fab fa-whatsapp"></i>
            Chat with us
          </a>

          <h2
            className="mt-4"
            style={{ color: "#002c97", fontSize: "32px", marginBottom: "0px" }}
          >
            Easy Way to Achieve a High Paid Tech Job
          </h2>
          <div className="cards-container">
            {cardData.map((card) => (
              <div key={card.id} className="easy-way-cards">
                <div className="card-icon">
                  <img src={card.icon} alt={card.text} />
                </div>
                <p>{card.text}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="conference-hall-section bg-light pt-3 pb-4">
          <h2 className="success-stories-heading text-center">
            <span> Building Your Network</span> <br /> Connections for Career
            Success
          </h2>
          <div className="network-container d-flex flex-column align-items-center">
            <img
              src="https://iqteche.in/static/media/wl_client_images/ec30e85bd07843bfb3b845b8f99cc05f.jpg"
              alt="Conference Meeting"
              className="conference-image"
            />
            {/* Points */}
            <div className="network-points text-left mt-4  container">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="network-item">
                    <div className="icon-box">
                      {/* <Users className="icon" /> */}
                      <span className="icon">
                        <PiUsersBold />
                      </span>
                    </div>
                    <div>
                      <h2 className="point-title">Meet Industry Pros</h2>
                      <p className="point-text">
                        Internships connect you with mentors and potential
                        employers.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="network-item">
                    <div className="icon-box">
                      {/* <Users className="icon" /> */}
                      <span className="icon">
                        <PiUsersBold />
                      </span>
                    </div>
                    <div>
                      <h2 className="point-title">Attend Events</h2>
                      <p className="point-text">
                        Join company workshops and training to expand
                        opportunities.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="network-item">
                    <div className="icon-box">
                      {/* <Users className="icon" /> */}
                      <span className="icon">
                        <PiUsersBold />
                      </span>
                    </div>
                    <div>
                      <h2 className="point-title">Networking Impact</h2>
                      <p className="point-text">
                        About 80% of jobs are found through networking
                        connections.
                      </p>
                    </div>
                  </div>
                </div>

                <div className=" col-12 col-md-6 ">
                  <div className="network-item">
                    <div className="icon-box">
                      {/* <Users className="icon" /> */}
                      <span className="icon">
                        <PiUsersBold />
                      </span>
                    </div>
                    <div>
                      <h2 className="point-title">Gain Real-World Exposure</h2>
                      <p className="point-text">
                        Hands-on industry exposure for confidence and career
                        growth.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="container pt-5 pb-4">
          <h2 className="success-stories-heading text-center">
            <span> Learn By Doing Work On Real Projects</span> <br /> & Develop
            Skills That Companies Need
          </h2>

          <div className="row">
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="project-cards d-flex algin-items-center shadow">
                <img
                  className="project-card-img"
                  src="https://iqteche.in/static/media/wl_client_images/6d1a6ec3e7d84542a75e69b884c0b461.jpg"
                  alt="Project Based Learning"
                />
                <div className="ms-3 mt-2">
                  <h3>TravelMate</h3>
                  <p>
                    A mobile app where users explore destinations, book trips
                    easily, and enjoy unique travel experiences.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="project-cards d-flex algin-items-center shadow">
                <img
                  className="project-card-img"
                  src="https://iqteche.in/static/media/wl_client_images/9f6db43e802b41e4a1e739c0e9bb2ab1.jpg"
                  alt="Project Based Learning"
                />
                <div className="ms-3 mt-2">
                  <h3>BioScan</h3>
                  <p>
                    A smart diagnostic app that uses advanced technology to
                    analyze health data quickly and accurately.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="project-cards d-flex algin-items-center shadow">
                <img
                  className="project-card-img"
                  src="https://iqteche.in/static/media/wl_client_images/d152abae2e6743f6873383159214670f.png"
                  alt="Project Based Learning"
                />
                <div className="ms-3 mt-2">
                  <h3>TranspoX</h3>
                  <p>
                    {" "}
                    A smart logistics diagnostic app that monitors fleet health,
                    routes, and cargo in real time.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="project-cards d-flex algin-items-center shadow">
                <img
                  className="project-card-img"
                  src="https://iqteche.in/static/media/wl_client_images/a3a7bbbf29c143bf8fb32d9929e6374e.jpg"
                  alt="Project Based Learning"
                />
                <div className="ms-3 mt-2">
                  <h3>Web Store App</h3>
                  <p>
                    Creating an Amazon-like e-commerce site with login and
                    products
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <div className="project-cards d-flex algin-items-center shadow">
                <img
                  className="project-card-img"
                  src="https://iqteche.in/static/media/wl_client_images/2290cfc5f7ea48f38a93dd62ea1258a2.png"
                  alt="Project Based Learning"
                />
                <div className="ms-3 mt-2">
                  <h3>Virtual Warfare</h3>
                  <p>
                    VR shooting game where players fight in realistic
                    battlefields using lifelike weapons and teamwork.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose IBIX?  */}
        <section>{ComparisonTable()}</section>

        {/* Certification  */}
        <section className="container certificate-container">
          <div className="row">
            <div className="col-12 col-lg-6">
              <div>
                <h2 className="certificate-text">
                  Industry Qualified Tech Certificate
                </h2>
                <div className="col-12 col-lg-6">
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/3efc285f8b084ea19436cbe89aff9e0d.png"
                    alt="IQT Certification"
                    className="w-100 certificate-img  d-lg-none"
                  />
                </div>
                <p className="quotes-text">
                  <span>Trusted Everywhere, Easy to Share</span> & {"  "}
                  <span>Where companies chase your talent</span>
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <img
                src="https://iqteche.in/static/media/wl_client_images/3efc285f8b084ea19436cbe89aff9e0d.png"
                alt="IQT Certification"
                className="w-100 certificate-img d-none d-lg-block shadow"
              />
            </div>
          </div>
        </section>
        <RequestCallButton />
        {/*Pricing Container*/}
        <section className="mt-5 mb-5">
          <div className="pricing-cont pt-5 pb-4">
            <h2 className="success-stories-heading ps-3">
              Learn <span>Today</span>, Lead <span>Tomorrow</span> <br />
              With IBIX Support
            </h2>
            {pathname === "/courses/fullstack" && (
              <p className=" ps-3">
                We Are Providing Best, Top Most Software Training and Job
                Placement Assistance in Hyderabad
              </p>
            )}

            {pathname === "/courses/specializations" && (
              <p className=" ps-3">
                Advanced Software Courses (AI & ML, Data Science, Cyber Security
                and more) With Affordable Prices In Hyderabad (HYD)
              </p>
            )}

            {pathname === "/courses/tech-tools" && (
              <p className=" ps-3">
                Software Tech Tools Training Courses in Hyderabad for Students &
                Professionals
              </p>
            )}

            {getPricing()}
            <span
              style={{
                color: "green",
                fontSize: "20px",
                marginLeft: "50px",
              }}
            >
              <GoDotFill /> Batch Starting Soon...
            </span>
          </div>
        </section>

        <section className="still-confused-card  pt-3 pb-3 pb-0">
          <div className="container">
            <div className="row algin-items-center">
              <div className="col-12 col-md-6">
                <h2 className="success-stories-heading ">
                  Still <span>Confused</span>?
                </h2>
                <p>Get in Touch with Our Career Expert!</p>
                <div className="d-flex align-items-center">
                  <img
                    src="https://iqteche.in/static/media/wl_client_images/cb4cda4a7f07435bac30725af17f8d1c.png"
                    alt="Call to Career Expert"
                    className="call-expert-img d-lg-none "
                  />

                  <a
                    href="https://wa.me/919100884508"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-us-link d-lg-none shadow"
                  >
                    Contact Us
                  </a>
                </div>

                <a
                  href="https://wa.me/919100884508"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-us-link d-none d-lg-block shadow"
                >
                  Contact Us
                </a>
              </div>
              <div className="col-12 col-md-6 ">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/cb4cda4a7f07435bac30725af17f8d1c.png"
                  alt="Call to Career Expert"
                  className="call-expert-img d-none d-lg-block"
                />
              </div>
            </div>
          </div>
        </section>
      </section>
    );
  };

  return (
    <>
      {getHelmetAndMetaTitle()}
      <section className="explore-courses">
        <div className="container">
          {/* <section className="typing-animation-cont">
            <div className="d-none d-lg-block">
              <h1 className="type-animation-heading">
                A Powerful Program Designed to Make You a{" "}
                <span><TypingAnimation /></span>
              </h1>
            </div>
            <div className=" d-lg-none">
              <h1 className="type-animation-heading">
                A Powerful Program Designed to Make You a
                <span><TypingAnimation /></span>
              </h1>
            </div>
          </section> */}

          {getTitle()}

          <div className="row">
            {filterCourse.map((course) => (
              <div className="col-12 mb-4" key={course.id}>
                <div className="course-card shadow-sm h-100">
                  <div className="row g-0 p-0">
                    <div className="col-md-3">
                      <img
                        src={course.img}
                        alt={course.title}
                        className="courses-img"
                      />
                    </div>
                    <div className="col-md-9 ps-3 pt-4 p-2">
                      <div className="card-body">
                        <h5 className="course-name-shine">
                          {course.title} | <strong>{course.tag}</strong>
                        </h5>

                        <p className="card-text">{course.desc}</p>
                        <button
                          className="show-course-details-btn"
                          onClick={() => toggleDetails(course.id)}
                        >
                          {openId === course.id
                            ? "Hide Journey"
                            : "View Journey"}
                        </button>
                        <div
                          className={`course-journey mt-3 ${
                            openId === course.id ? "open" : ""
                          }`}
                        >
                          {openId === course.id && (
                            <NoOppositeContent
                              journey={course.journey}
                              salary={course.salary}
                            />
                          )}
                        </div>
                        {/* <div className="">
                          <p>
                            <span className="actual-fee">
                              <FaIndianRupeeSign />
                              {course.actualPrice}/-
                            </span>
                          </p>
                          <p className="offer-fee-para">
                            <span className="offer-fee">
                              <FaIndianRupeeSign />
                              {course.offerPrice}/-
                            </span>
                          </p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* {!loading && !error && courses.length === 0 && (
            <p className="text-center">No courses found.</p>
          )} */}
          </div>
        </div>
        <RequestCallButton />
      </section>

      {renderAboutIBIXCourses()}
    </>
  );
};

export default ExploreCourses;
